import { Box, Checkbox, TableCell, TableRow, Typography } from "@material-ui/core";
import { FC, memo } from "react";
import { useDispatch } from "react-redux";
import CommentOutlinedIcon from "@mui/icons-material/CommentOutlined";
import { payrollToggleUserDate } from "actions/payrollAction";
import { ModalWindow } from "componentsNew/modals/ModalWindow";
import { EditPayrollNoteModalContent } from "componentsNew/modals/modalContent/PayrollModalContent";
import CustomIconButton from "componentsNew/buttons/CustomIconButton";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { PayrollRowData } from "types/Payroll";
import { isPayrollRowSelected } from "utils/payrollHelpers";
import { useStyles } from "./styles";

interface PropsType {
  row: PayrollRowData;
  tableNumber: number;
  isMobile?: boolean;
}

export const PayrollRow: FC<PropsType> = memo(({ row, tableNumber, isMobile }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const selctedUserDatesList = useTypeSelectors((state) => state.payrollTable.selctedUserDatesList);
  const isSelected = isPayrollRowSelected(selctedUserDatesList, row);
  const cellClass = `${classes.tableCell} ${classes.fixedHeight} ${isSelected ? classes.activeRow : ""}`;

  return (
    <TableRow>
      {tableNumber === 1 && (
        <>
          <TableCell className={cellClass}>
            <Checkbox
              onChange={() => dispatch(payrollToggleUserDate(row.user_id, row.date))}
              checked={isSelected}
              className={classes.selectCheckbox}
            />
          </TableCell>
          {!isMobile && (
            <TableCell className={cellClass}>
              <Typography>{row.user_name}</Typography>
            </TableCell>
          )}
        </>
      )}
      {tableNumber === 2 && (
        <>
          {isMobile && (
            <TableCell className={cellClass}>
              <Typography>{row.user_name}</Typography>
            </TableCell>
          )}
          <TableCell className={cellClass}>
            <Typography>{row.badge}</Typography>
          </TableCell>
          <TableCell className={cellClass}>
            <Typography>{row.station}</Typography>
          </TableCell>
          <TableCell className={cellClass}>
            <Typography>{row.agency}</Typography>
          </TableCell>
          <TableCell className={cellClass}>
            <Typography>{row.date}</Typography>
          </TableCell>
          <TableCell className={cellClass}>
            <Typography>{row.role}</Typography>
          </TableCell>
          <TableCell className={cellClass}>
            <Typography>{row.role_hours}</Typography>
          </TableCell>
          <TableCell className={cellClass}>
            <Typography>{row.pay_rate}</Typography>
          </TableCell>
          <TableCell className={cellClass}>
            <Typography>{row.pay}</Typography>
          </TableCell>
          <TableCell className={cellClass}>
            <Typography>{row.agency_pay}</Typography>
          </TableCell>
          <TableCell className={cellClass}>
            <Box className={classes.noteCell}>
              <ModalWindow
                buttonType={"custom"}
                modal_name={`payroll-note-${row.user_id}-${row.date}-${row.station_id}-modal`}
                modalTitle="Note"
                customButtonElement={
                  <CustomIconButton
                    icon={<CommentOutlinedIcon />}
                    iconColor={!row.comment ? "darkGray" : "white"}
                    theme={!row.comment ? "gray" : "blue"}
                  />
                }
              >
                <EditPayrollNoteModalContent report={row} />
              </ModalWindow>
            </Box>
          </TableCell>
        </>
      )}
    </TableRow>
  );
});
